import { useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Loader } from '@percent/cause-dashboard/common/components'
import { useProductOfferDetailPageStory } from '@percent/cause-dashboard/storyblok/product-offer-detail/useProductOfferDetailPageStory'
import { useProductPageAnalytics } from '@percent/cause-dashboard/common/hooks/useCausesDashboardAnalytics/useProductPageAnalytics'
import { PageViewSource } from '@percent/cause-dashboard/common/hooks/useCausesDashboardAnalytics/marketplaceAnalytics.types'
import { ProductOfferDetailCMSPageStoryBridge } from './ProductOfferDetailCMSPageStoryBridge'
import { EmptyState } from '@percent/cause-dashboard/app/common/components/emptyState/EmptyState'
import { useBreadcrumbs } from '@percent/cause-dashboard/app/layout/breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'

export function ProductOfferDetailCMSPage() {
  const { t } = useTranslation()
  const { offerDetailSlug } = useParams<{ offerDetailSlug: string }>()
  const { page } = useProductPageAnalytics()
  const query = useProductOfferDetailPageStory(offerDetailSlug)
  const lastTrackedTitle = useRef<string | null>(null)

  useBreadcrumbs([
    { label: t('breadcrumb.productOffers.title'), path: '/product-offers' },
    { label: query.story?.content.title ?? offerDetailSlug ?? '' }
  ])

  useEffect(() => {
    const title = query.story?.content.title

    if (title && lastTrackedTitle.current !== title) {
      lastTrackedTitle.current = title
      page(`${PageViewSource.ProductOfferDetail} ${title}`)
    }
  }, [page, query.story?.content.title])

  if (query.loading) {
    return <Loader isFullScreen />
  }

  if (query.error || !query.story) {
    return (
      <EmptyState
        illustration="no-search-results"
        title={t('productOffers.unavailableTitle')}
        description={t('productOffers.unavailableDescription')}
      />
    )
  }

  return <ProductOfferDetailCMSPageStoryBridge initialStory={query.story} />
}
